<template>
  <div class="batch-selection-container" data-test-id="batch-selection-container">
    <div class="batch-selection-card">
      <div class="batch-selection-card__title" data-test-id="batch-selection__title">
        <slot name="title" />
      </div>

      <div class="batch-selection-card__info" data-test-id="batch-selection__info" v-html="$t('batchSelection.info')" />

      <div class="batch-selection-card__actions">
        <slot name="extra-actions" />

        <PopoverMenu v-if="hasSlotMore" data-test-id="batch-selection-more-menu">
          <template #trigger>
            <Btn color="dark" icon data-test-id="batch-selection-more-button">
              <MoreIcon16 />
            </Btn>
          </template>

          <template #items-list>
            <slot name="more" />
          </template>
        </PopoverMenu>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MoreIcon16 from '@/components/Icons/MoreIcon16.vue';
import { hasSlotContent } from '@components/slots';

export default defineComponent({
  name: 'BatchSelection',

  components: {
    MoreIcon16,
  },

  computed: {
    hasSlotMore() {
      return hasSlotContent(this.$slots.more, {});
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';
@use 'mixins/typography';

.batch-selection-container {
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;
  padding: 0 120px;
  pointer-events: none;
  z-index: settings.$batchSelectZIndex;
  bottom: 40px;
  top: auto;
}

.batch-selection-card {
  @include typography.typography-14-normal;

  border-radius: settings.$border-radius;
  background: colors.$color-grey-800;
  color: colors.$color-white;
  display: flex;
  height: 56px;
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
  pointer-events: all;
  max-width: 900px;
  margin: auto;
}

.batch-selection-card__title {
  @include typography.typography-14-medium;
}

.batch-selection-card__info {
  color: colors.$color-white-50;

  strong {
    font-weight: inherit;
  }
}

.batch-selection-card__actions {
  display: flex;
  gap: 8px;
  align-items: center;
}
</style>
